import BreadcrumbHome from "../../components/BreadcrumbHome";
import { useNavigate, useParams, Navigate } from "react-router";
import MyWorkspace from "../../components/MyWorkspace";
import { useEffect, useState } from "react";
import NotFound from "../../components/HttpError/NotFound";
import "./MyWorkspacePage.scss";

const MyWorkspacePage = () => {
  const { tab } = useParams();
  const [defaultTab, setDefaultTab] = useState(0);
  const [breadcrumbItem, setBreadcrumbItem] = useState("");
  const navigate = useNavigate();

  const goBackToCTTab = () => navigate("/marketplace");

  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "Home",
      elementKey: "submission",
      text: "Home",
      url: `/`,
    },
    {
      label: "External Submission",
      elementKey: "submission",
      text: "My Workspace",
      disabled: true,
    },
    {
      label: "External Submission",
      elementKey: "submission",
      text: breadcrumbItem,
      disabled: true,
    },
  ];
  const validTabs = [
    "all-order-bundles",
    "my-orders",
    "my-estimates",
    "my-drafts",
  ];

  const getTabIndex = (tabName: string | undefined): number => {
    const tabMap: Record<string, number> = {
      "all-order-bundles": 0,
      "my-orders": 1,
      "my-estimates": 2,
      "my-drafts": 3,
    };
    return tabMap[tabName || "all-order-bundles"] ?? -1;
  };

  const getTabName = (tabIndex: number): string => {
    const nameMap: Record<number, string> = {
      0: "All Order Bundles",
      1: "My Orders",
      2: "My Estimates",
      3: "My Drafts",
    };
    return nameMap[tabIndex] || "All Order Bundles";
  };
  useEffect(() => {
    const tabIndex = getTabIndex(tab);
    setDefaultTab(tabIndex);
    setBreadcrumbItem(getTabName(tabIndex));
  }, [tab]);

  // Redirect to default tab if no tab parameter is provided
  if (!tab) {
    return <Navigate to="/my-workspace/all-order-bundles" replace />;
  }

  if (tab && !validTabs.includes(tab)) {
    return <NotFound />;
  }

  const handleBreadcrumb = (tabIndex: number) => {
    setDefaultTab(tabIndex);
  };

  return (
    <div className="myworkspace-main-container-wrapper">
      <section className="commercial-hub-header-banner">
        <div className="commercial-hub-header-content">
          <div className="breadcrumb-grid">
            <BreadcrumbHome
              items={breadcrumbItems}
              ariaLabel="Breadcrumb navigation"
            />
          </div>
          <h1 className="commercial-hub-header-title">My Workspace</h1>
        </div>
      </section>
      <section className="myworkspace-tile-container"></section>
      <div className="workspace-container">
        <MyWorkspace
          goBackToCTTab={goBackToCTTab}
          defaultTab={defaultTab}
          handleBreadcrumb={handleBreadcrumb}
        />
      </div>
    </div>
  );
};

export default MyWorkspacePage;
